import { ModulesTranslation } from 'locales/de/pages/AWPM-FWPM/modules';

const en: ModulesTranslation = {
  title: { awpm: 'AWPM module catalog', fwpm: 'FWPM module catalog' },
  lecturer: 'Lecturer',
  lecturers: 'Lecturers',
  courseOfStudy: 'Course of study',
  faculty: 'Responsible course of study',
  moduleResponsible: 'Responsible for module',
  moduleResponsibleTooltip:
    'Is necessary to complete the module but it can be saved as a draft without this information.',
  semester: 'Semester',
  grouping: 'Group',
  sorting: 'Category',
  awpm: 'awpm',
  fwpm: 'fwpm',
  activated: 'Activated',
  deactivated: 'Deactivated',
  noModule: 'There are no modules',
  seatsAvailable: 'Seats',
  seatConfiguration: 'total, split in {{config}}',
  goBackFromDetailView: 'Back to the modules',
  goBackToSelections: 'Back to Selections',
  isNotTakingPlace: 'Not formed',
  takesPlace: 'Formed',
  isNotTakingPlaceButton: 'Not taking place',
  takesPlaceButton: 'Taking place',
  isNotTakingPlaceDialogTitle: 'Did not take place',
  isNotTakingPlaceDialoginfo:
    'Do you really want to set the state of the module to did not take place? In this case all participants of the module will be notified about this change by e-mail.',
  deactivate: 'Deactivate',
  activate: 'Activate',
  draft: 'Draft',
  incomplete: 'Incomplete',
  complete: 'Complete',
  signOut: 'Sign out',
  signIn: 'Sign in',
  position: 'Position',
  addStudent: 'Add student',
  pauseSuccessor: 'Pause Successors',
  resumeSuccessor: 'Resume Successors',
  studentNumber: 'Matriculation number',
  registeredParticipants: 'Registered participants',
  admissionCriteria: 'Admission criteria',
  listOfParticipants: 'List of participants',
  listOfDischarged: 'List of discharged',
  showStudentsWithEnoughDesiredModules: 'Show students who already have enough modules',
  explanationOfSeatDistributionTitle: 'Note about the selection settings',
  explanationOfSeatDistributionText:
    'If a number is entered in the "Places" field, this number of places is permanently reserved for the specified degree programs. If a 0 is entered in the field or the field is left blank, no places are reserved for the configured degree programs. As a result, students are first allocated to other modules with reserved places and only then to this module.',
  dischargeDialogText: 'The next student on the waiting list will move up.',
  dischargeDialogTextNotMovingUp:
    'The move-up procedure is currently deactivated/paused. No student from the waiting list will move up.',
  dischargeDialogTextPausedSuccesor:
    'The move-up procedure is currently deactivated/paused. Would you like to activate this once and allow the first student from the waiting list (if available) to move up for this module?',
  dischargeConfirmOnlyDischarge: 'No (sign out only)',
  dischargeConfirmMoveUp: 'Yes (move up)',
  table: {
    mtrNumber: 'Matriculation number',
    firstName: 'First name',
    lastName: 'Last name',
    courseOfStudy: 'Course of study',
    semester: 'Semester',
    wishlistPosition: 'Position in wishlist',
    drawnNumber: 'Lottery key',
    actions: 'Actions'
  },
  setStateConfirm: {
    setActiveTitle: 'Are you sure?',
    setInavctiveTitle: 'Are you sure?',
    setActive: 'Do you want to activate the module?',
    setInactive: 'Do you want to deactivate the module?'
  },
  alerts: {
    failedLoading: 'Could not load modules',
    failedLoadingModule: 'Could not load modules',
    failedLoadingConfiguration: 'Could not load configuration',
    failedLoadingCourseOfStudy: 'Could not load courses of study',
    failedLoadingPrioritization: 'Could not load prioritization',
    failedLoadingCourses: 'Coult not load courses',
    deleteFailed: 'The module could not be deleted',
    deleteSuccessful: 'The module was successfully deleted',
    successfulCreate: 'The module was successfully created',
    failedCreate: 'The module could not be created',
    successfulUpdate: 'The module was successfully updated',
    failedUpdate: 'The module could not be updated',
    failedAttachmentUpload: 'The attachments could not be uploaded',
    deleteParConfSuccessful: 'The participant configuration was successfully deleted',
    deleteParConfFailed: 'The participant configuration could not be deleted',
    changeStateFailed: 'The status of the module could not be changed',
    changeStateSuccssful: 'The status of the module was successfully changed',
    dischargeStudentFailed: 'The logout from the module failed',
    dischargeStudentSuccessful: 'The logout from the module was successful',
    addStudentSuccessful: 'The student was successfully added to the selection',
    addStudentFailed: 'The student could not be added to the selection',
    addStudentInvalidForm: 'Please select a student to add.',
    notAShibUser: 'The student is not from Shibboleth. A Course of Study has to picked aswell',
    emailHasToBeEntered: 'An email has to be entered before a course of Study can be selected',
    noLotteryToAddTo:
      'The students can not be added to a module until the selection reached the status move-up procedure.',
    noSuccessorPossible:
      'Pause Successors can only be used when successors are activated on the module.',
    successfulPauseDischarge:
      'You have deactivated the succession procedure for this module until further notice. Please note that no students will move up until you have reactivated the move-up procedure.',
    successfulContinueDischarge:
      'You have reactivated the succession procedure for this module and participants are now moving up. This may take a few minutes. Refresh the page again at a later time.'
  },
  steps: {
    SubjectCategory: 'Category',
    GeneralInfo: 'General info',
    Participants: 'Participants',
    PrioritizationAndApproval: 'Prioritization & approval',
    ReviewAndCreate: 'Review & create'
  },
  deleteConfirm: {
    title: 'Are you sure?',
    message: 'Do you really want to permanently delete this module?'
  },
  create: {
    title: { awpm: 'New AWPM Module', fwpm: 'New FWPM Module' },
    category: {
      selectCategory: 'Choose category',
      fwpm: 'Electives and compulsory electives',
      awpm: 'Subject-specific elective modules'
    },
    GeneralInfo: {
      name: 'Subject name',
      moduleOfficer: 'Module officer',
      salutationMale: 'Mr.',
      salutationFemale: 'Mrs.',
      salutationOther: 'Divers',
      lecturer: {
        title: 'Lecturer',
        salutation: 'Salutation',
        firstName: 'First name',
        lastName: 'Last name'
      },
      grouping: {
        title: 'Grouping & Sorting',
        grouping: 'Grouping',
        sorting: 'Sorting'
      },
      description: 'Description',
      attachments: 'Files',
      attachmentPlaceholder: 'Upload Files (pdf, zip)'
    },
    periodsAndParticipants: {
      participants: {
        title: 'Participants',
        min: 'Min. total participants',
        max: 'Max. total participants'
      },
      isMoveUpActive: 'Move-up procedure active',
      takingPlace: 'Takes Place'
    },
    prioritizationAndApproval: {
      selectAll: 'Select all',
      configWarning:
        'All course of study configurations without reserved seats will be disregarded!',
      title:
        'Please note that the selected courses of study must share the selection with you so that the students can see your FWPMs. Therefore, please consult with the concerned C-Admins regarding an appointment!',
      addNew: 'Add new',
      altLeastOneConfigurationRequired:
        'The prioritization and approval for at least on course of Study must be defined.',
      participants: 'Total Participants',
      openSeats: 'not yet reserved',
      reservedMoreSeats: 'too much reserved',
      participantConfiguration: {
        courseOfStudy: 'Course of study',
        courseOfStudyIsGlobal: 'All courses',
        seats: 'seats',
        admissionCriteria: 'Admission criteria',
        subjectType: 'Selectable as',
        prioritization: 'Prioritization',
        prioritizationEmpty: 'Select prioritization...',
        customPrioritization: 'Custom prioritization',
        customPrioEmpty: 'Create custom prioritization...',
        isGlobal: 'Module selectable for all courses of study',
        isGlobalError: 'There can only be one configuration for all courses',
        excludeCourses: 'Exclude courses',
        chooseCoursestoExclude: 'Select courses to exclude',
        bachelor: 'Bachelor',
        master: 'Master'
      },
      distributeSeats: 'Remaining seat distribution',
      distributingSeats: 'Remaining seats are distributed',
      automaticSeatDistribution: 'Distribute seats automatic',
      awpmDistributingSeats:
        'Distribute remaining seats to all students.\n\nAll remaining seats will be distributed to all other students according to algorithm, including students who belong to a program that has already been reserved fixed seats.',
      fwpmDistributingSeats:
        'Distribute remaining places to all other students from admitted programs.\n\nHere all remaining places are distributed according to algorithm to all other students from programs that have already been admitted and got fixed places in the module. Not to students of ALL available study programs.',
      distributeEvenly: 'Evenly distribute between participating courses',
      fillUpByKey: 'Fill up with students of participating courses by admission key'
    },
    modulePreview: {
      title: 'Title',
      lecturer: 'Lecturer',
      category: 'Category',
      faculty: 'FÜ',
      group: 'Group',
      interdisciplinary: 'Interdisciplinary'
    }
  },
  edit: {
    title: { awpm: 'Edit AWPM', fwpm: 'Edit FWPM' }
  },
  status: 'Status',
  statusComplete: 'Complete',
  statusCompleteDraft: 'Draft (Complete)',
  statusIncomplete: 'Incomplete',
  statusIncompleteDraft: 'Draft (Incomplete)'
};

export default en;
